import { Pipe, PipeTransform } from '@angular/core';
import { WorkspaceStatus } from '@workspaces/models/agent';

@Pipe({
  name: 'statusIcon',
  pure: true,
  standalone: true
})
export class StatusIconPipe implements PipeTransform {
  transform(status: WorkspaceStatus['status'] | string | null | undefined): string {
    if (!status) {
      return 'gpp_maybe';
    }

    const normalizedStatus = status.toUpperCase();

    switch (normalizedStatus) {
      case 'NOT_STARTED':
        return 'not_started';
      case 'IN_PROGRESS':
        return 'hourglass_bottom';
      case 'COMPLETED':
        return 'check_circle';
      case 'FAILED':
        return 'error';
      case 'STATUS_NOT_FOUND':
        return 'gpp_maybe';
      default:
        return 'gpp_maybe';
    }
  }
}
